import React, {useEffect, useRef} from "react";
import HomePage from "./HomePage";
import api from "./../../api";

const ModalConfirmation = () => {
    return (
        <div className="modal fade" id="loadingModal" tabIndex="-1" aria-labelledby="loadingModalLabel"
             aria-hidden="true">
            <div className="modal-dialog modal-sm">
                <div className="modal-content text-center">
                    <div className="modal-body">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Carregando...</span>
                        </div>
                        <p className="mt-3">Confirmando sua conta, por favor aguarde...</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

const AccountConfirmation = () => {
    const hasFetched = useRef(false);

    useEffect(() => {
        if (!hasFetched.current) {
            hasFetched.current = true;
            const modalElement = document.getElementById("loadingModal");
            if (modalElement) {
                const bootstrapModal = new window.bootstrap.Modal(modalElement, {
                    backdrop: "static",
                    keyboard: false,
                });
                bootstrapModal.show();
            }

            const queryParams = new URLSearchParams(window.location.search);
            const activationToken = queryParams.get("activation_token");

            if (!activationToken) {
                window.showAlert(
                    'Erro',
                    'Link de ativação inválido. Solicite um novo cadastro ou entre em contato com o suporte.',
                    'error',
                    '/admin/login'
                );
                return;
            }

            setTimeout(() => {
                api.post("users/activate-account?activation_token=" + encodeURIComponent(activationToken), {})
                    .then((response) => {
                        window.showAlert(
                            'Sucesso',
                            response.data?.message || 'Conta ativada com sucesso! Faça login para continuar.',
                            'success',
                            '/admin/login'
                        );
                    })
                    .catch((error) => {
                        const message =
                            error.response?.data?.error ||
                            error.response?.data?.message ||
                            'Não foi possível confirmar sua conta.';
                        window.showAlert('Erro', message, 'error', '/admin/login');
                    });
            }, 1000);
        }
    }, []);

    return (
        <div>
            <HomePage/>
            <ModalConfirmation/>
        </div>
    );
};

export default AccountConfirmation;
